import { useQuery } from '@tanstack/react-query'
import { siteContextQuery } from '@/features/site/context'
import { WebsitePage } from './WebsitePage'

/** /site: the public website, for single-address mode (development) where no www. exists. */
export function WebsitePreview() {
  const site = useQuery(siteContextQuery())
  return <WebsitePage context={site.data ?? null} />
}
